import React from 'react'
import { Route } from 'react-router-dom'
import CategoriesView from '../../../../components/Categories/CategoriesView'

const CategoriesConfigurationsRoutes = ({ match }) => (
  <Route path={match.path} component={CategoriesView} />
)

export default CategoriesConfigurationsRoutes
